export const contactTranslations = {
    en: {
        title: 'Contact Us',
        subtitle: 'Have questions or need assistance? We\'re here to help. Reach out to our team using any of the methods below.',
        getInTouch: 'Get in Touch',
        email: 'sander@invoicehappens.com',
        emailDescription: 'We aim to respond within 24 hours',
        location: 'Utrecht, Netherlands',
        address: 'Maliebaan 53Z, 3581 CD',
        joinCommunity: 'Join Our Community',
        communityDescription: 'Connect with us on social media to stay updated on the latest features, tips, and news about InvoiceHappens.',
        socialLinks: {
            twitter: {
                username: '@sanderbz',
                description: 'Follow me for updates and tips'
            },
            linkedin: {
                name: 'Sander van Meggelen',
                description: 'Connect with my professional network'
            }
        }
    },
    nl: {
        title: 'Neem Contact Op',
        subtitle: 'Heb je vragen of hulp nodig? Wij staan voor je klaar. Neem contact op met ons team via een van de onderstaande methoden.',
        getInTouch: 'Kom in Contact',
        email: 'sander@invoicehappens.com',
        emailDescription: 'We streven ernaar binnen 24 uur te reageren',
        location: 'Utrecht, Nederland',
        address: 'Maliebaan 53Z, 3581 CD',
        joinCommunity: 'Word Lid van Onze Community',
        communityDescription: 'Volg ons op sociale media om op de hoogte te blijven van de nieuwste functies, tips en nieuws over InvoiceHappens.',
        socialLinks: {
            twitter: {
                username: '@sanderbz',
                description: 'Volg mij voor updates en tips'
            },
            linkedin: {
                name: 'Sander van Meggelen',
                description: 'Verbind met mijn professionele netwerk'
            }
        }
    }
}; 